<ng-container *ngIf="submission$ | async as sub">
  <div class="submission-container">
    <div class="d-flex flex-column gap-1">
      <div class="submission-name">{{ submissionName$ | async }}</div>
      <div i18n class="submission-owner">Owner: {{ submissionOwner$ | async }}</div>
    </div>
    <app-status-pill class="mt-auto mb-auto" [statusPill]="sub?.statusPill" />
  </div>
</ng-container>
